var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('user-onfido',{attrs:{"sdk-token":_vm.sdkToken},on:{"complete":_vm.handleComplete}})}
var staticRenderFns = []

export { render, staticRenderFns }